import { render, staticRenderFns } from "./toOther.vue?vue&type=template&id=71703966&scoped=true"
import script from "./toOther.vue?vue&type=script&lang=js"
export * from "./toOther.vue?vue&type=script&lang=js"
import style0 from "./toOther.vue?vue&type=style&index=0&id=71703966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71703966",
  null
  
)

export default component.exports